export default __webpack_public_path__ + "static/media/wordpress.078f3c74.png";